var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarTutorialsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.01 18.45H21.735V4.73995C21.735 3.61495 20.835 2.69995 19.71 2.69995H4.29C3.165 2.69995 2.25 3.61495 2.25 4.73995V18.45H0.99C0.435 18.45 0 18.9 0 19.44C0 19.995 0.435 20.43 0.99 20.43H23.01C23.55 20.43 24 19.995 24 19.44C24 18.9 23.55 18.45 23.01 18.45ZM15.42 12.285L11.025 14.79C10.77 14.94 10.455 14.94 10.2 14.79C9.945 14.64 9.795 14.37 9.795 14.07V9.07495C9.795 8.77495 9.945 8.50495 10.2 8.35495C10.455 8.20495 10.77 8.20495 11.025 8.35495L15.42 10.86C15.675 10.995 15.84 11.28 15.84 11.565C15.84 11.865 15.675 12.15 15.42 12.285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarTutorialsActive);
export default __webpack_public_path__ + "static/media/navbar-tutorials-active.91ca19c83b9a576e718588f126cd5e9e.svg";
export { ForwardRef as ReactComponent };